import { Ambulance } from './ambulance'
import { CareShield } from './care-shield'
import { Cash } from './cash'
import { Compare } from './compare'
import { CreditCard } from './credit-card'
import { DiscountCodes } from './discount-codes'
import { Error } from './error'
import { Hospital } from './hospital'
import { Invoice } from './invoice'
import { Lab } from './lab'
import { Map } from './map'
import { MoneyShield } from './money-shield'
import { PiggyBank } from './piggy-bank'
import { Prescriptions } from './prescriptions'
import { Rx } from './rx'
import { Star } from './star'
import { Telehealth } from './telehealth'
import { UploadingDoc } from './uploading-doc'
import { UploadDoc } from './upload-doc'
import { UploadingReceipt } from './uploading-receipt'
import { UploadReceipt } from './upload-receipt'

const largeIcons: { [key: string]: any } = {
  ambulance: Ambulance,
  careShield: CareShield,
  cash: Cash,
  compare: Compare,
  creditCard: CreditCard,
  discountCodes: DiscountCodes,
  error: Error,
  hospital: Hospital,
  invoice: Invoice,
  lab: Lab,
  map: Map,
  moneyShield: MoneyShield,
  piggyBank: PiggyBank,
  prescriptions: Prescriptions,
  rx: Rx,
  star: Star,
  telehealth: Telehealth,
  uploadingDoc: UploadingDoc,
  uploadDoc: UploadDoc,
  uploadingReceipt: UploadingReceipt,
  uploadReceipt: UploadReceipt,
}

export default largeIcons
